@if ((profile$ | async); as profile) {
<ct-profile-card>
  <ct-user-global-info>
    <ct-initials-circle>
      {{ profile?.initials }}
    </ct-initials-circle>
    <ct-user-name class='mb-5px'>
      {{ profile?.firstName }} {{ profile?.lastName }}
    </ct-user-name>
    <mgt-platform-chip [platforms]='profile?.platforms' />
  </ct-user-global-info>
  <ct-user-contact-info>
    <ct-email>
      <mat-icon class='material-icons-outlined'>email</mat-icon>
      {{ profile?.email }}
    </ct-email>
    @if (profile.recentBounce) {
    <ct-error-message-email>
      <mat-icon>error_outline</mat-icon>
      {{ 'EMAIL_ERROR' | translate}}
    </ct-error-message-email>
    }
    @if (profile?.mobile) {
    <ct-mobile>
      <mat-icon class='material-icons-outlined'>smartphone</mat-icon>
      {{ profile?.mobile }}
    </ct-mobile>
    }
    @if (profile?.phone) {
    <ct-phone>
      <mat-icon class='material-icons-outlined'>phone</mat-icon>
      {{ profile?.phone }}
    </ct-phone>
    }
    @if (!isMyUser) {
    <ct-last-login>
      <mat-icon class='material-icons-outlined'>login</mat-icon>
      {{ "LAST_LOGIN" | translate }}
      @if (lastLoginData) {
      {{ lastLoginData | date: "shortDate":"":currentLang }}
      } @else {
      {{ "NEVER" | translate }}
      }
    </ct-last-login>
    }
  </ct-user-contact-info>
</ct-profile-card>
}